import { memo, useEffect, useState } from "react";
import { Box, IconButton, Paper, Stack, TextField } from "@mui/material";
import { Item } from "../../../../../models/assessment";
import ResourcesView from "../../../components/resources";
import RichTextEditor from "../../../components/rich-text/rich-text-editor";
import { Add, Cancel } from "@mui/icons-material";

interface SubHeaderProps {
    item: Item;
    setSaved: React.Dispatch<React.SetStateAction<boolean>>;
    register: (id: string, getItem: () => Item) => void;
    saveFunction: () => void;
}
  
function SubHeader({ item, register, setSaved, saveFunction }: SubHeaderProps) {
    const [localItem, setLocalItem] = useState(item);
    const [resourcesOpen, setResourcesOpen] = useState(false);
    const [resourceAnchorEl, setResourceAnchorEl] = useState<null | HTMLElement>(null);
    
    useEffect(() => {
        register(item.id, () => localItem);
    }, [item.id, localItem, register]);

    const handleChange = (field: keyof Item, value: any) => {
      setSaved(false);
      setLocalItem((prev) => ({ ...prev, [field]: value }));
      saveFunction();
    };

  return (
    <Paper 
      sx={{
          backgroundColor: '#fff',
          padding: 2,
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '1000px',
          gap: 2
      }}
    >
      <RichTextEditor
        id={localItem.id}
        type="title"
        value={localItem.title}
        onChange={(val) => handleChange("title", val)}
        fullBorder={false}
        userPlaceholder="Untitled Subheader"
      />

      <RichTextEditor
        id={localItem.id}
        type="description"
        value={localItem.description}
        onChange={(val) => handleChange("description", val)}
      />


        <Box
          onClick={(event: React.MouseEvent<HTMLElement>) => setResourceAnchorEl(event.currentTarget)}
          sx={{
              width: 50,
              height: 50,
              minWidth: 50,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              border: "1px dashed #ccc",
              flexShrink: 0,
              borderRadius: 2,
          }}
        >
          <Add sx={{ fontSize: 24, color: "#757575" }} />
        </Box>

        <Stack direction="row" spacing={1} alignItems="center" sx={{ overflowX: "auto", width: "100%", pb: 1 }}>
          {localItem.resources.map((res, i) => {
              return (
                  <Paper
                      key={`${res}-resource-${i}`}
                      sx={{
                        width: 50,
                        height: 50,
                        minWidth: 50,
                        overflow: "hidden",
                        position: "relative",
                        borderRadius: 1,
                        backgroundColor: "#000",
                        flexShrink: 0,
                      }}
                  >
                      <img
                          src={res}
                          alt={`resource-${i}`}
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />

                      <IconButton
                          size="small"
                          sx={{
                              position: "absolute",
                              top: 1,
                              right: 0.5,
                              backgroundColor: "rgba(0,0,0,0.3)",
                              color: "#fff",
                              padding: "2px",
                              "&:hover": {
                              backgroundColor: "rgba(0,0,0,0.5)",
                              },
                          }}
                          onClick={() => {
                              handleChange("resources", localItem.resources.filter((r) => r !== res));
                          }}
                      >
                          <Cancel fontSize="small" />
                      </IconButton>
                  </Paper>
              );
          })}
        </Stack>

        <ResourcesView
          id={localItem.id}
          resourceAnchorEl={resourceAnchorEl}
          setResourceAnchorEl={setResourceAnchorEl}
          onselect={(res: string) => handleChange("resources", [...localItem.resources, res])}
        />
    </Paper>
  );
}

export default memo(SubHeader);